import { useTranslation } from 'next-i18next'
import { Trans } from 'react-i18next'

import { serverSideConfigs, t } from 'localization'
import { FCLink } from 'shared/components/Links'
import StaticPage from 'shared/components/StaticPage'
import { PagesQA } from 'shared/dataAttributes'
import { FCGetServerSidePropsContext, getServerPageProps } from 'shared/utils/getServerSideProps'
const TP = 'pages.aboutUs'

const AboutUs = () => {
  const tv = useTranslation()
  return (
    <StaticPage
      qaAttr={PagesQA.AboutUs}
      title={t(`${TP}.aboutUs`, 'About Us')}
      heroImagePath="/static/staticPages/about-us.png"
    >
      <StaticPage.Paragraph>
        <Trans i18nKey={`${TP}.established`} t={tv.t}>
          Established in New York City over fifteen years ago, Flight Club revolutionized sneaker
          retail as the original consignment store for rare shoes. Carrying the latest drops,
          coveted classics and hard-to-find grails, Flight Club has evolved from a one-stop sneaker
          destination to a cultural hub for sneaker enthusiasts and novices alike.
        </Trans>
      </StaticPage.Paragraph>
      <StaticPage.Paragraph>
        <Trans
          i18nKey={`${TP}.withThree`}
          t={tv.t}
          defaults="With three brick-and-mortar locations in <0>New York City</0>, <1>Los Angeles</1> and <2>Miami</2>, Flight Club remains the premier source for authentic, rare shoes."
          components={[
            <FCLink qaAttr={PagesQA.AboutUsFcnyLink} href="/storelocator" />,
            <FCLink qaAttr={PagesQA.AboutUsFclaLink} href="/storelocator" />,
            <FCLink qaAttr={PagesQA.AboutUsFcmiaLink} href="/storelocator" />,
          ]}
        />
      </StaticPage.Paragraph>
    </StaticPage>
  )
}
export const getServerSideProps = async (context: FCGetServerSidePropsContext) => {
  const { res, locale } = context
  return {
    props: {
      ...(await getServerPageProps(context)),
      ...(await serverSideConfigs(res, locale)),
    },
  }
}
export default AboutUs
